import React, { useState, useEffect } from "react";
import { Box, ListItem, Typography, List, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ActiveLanguages } from "../../../utility/interfaces/masterDataInterfaces";
import styles from "./CustomLanguage.module.scss";
import { LANGUAGE_ICONS } from "../../../utility/constants/common-constants";

interface CustomLanguageProps {
  onLangMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
  selectedLanguage: string;
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  supportedLanguages: ActiveLanguages[];
  onChangeLang: (lang: ActiveLanguages) => void;
}

const CustomLanguage: React.FC<CustomLanguageProps> = ({
  onLangMenuOpen,
  selectedLanguage,
  anchorEl,
  open,
  onClose,
  supportedLanguages,
  onChangeLang,
}) => {
  const [currentLanguage, setCurrentLanguage] = useState(selectedLanguage);

  useEffect(() => {
    setCurrentLanguage(selectedLanguage);
  }, [selectedLanguage]);

  const iconSrc = LANGUAGE_ICONS[currentLanguage] || LANGUAGE_ICONS["English"];

  const handleMenuItemClick = (lang: ActiveLanguages) => {
    setCurrentLanguage(lang.languageName);
    onChangeLang(lang);
    onClose();
  };

  return (
    <>
      <List className={styles.languageList}>
        <ListItem className={styles.languageListItem} onClick={onLangMenuOpen}>
          <Box className={styles.languageBox}>
            <img
              key={currentLanguage}
              src={iconSrc}
              alt={currentLanguage}
              className={styles.languageIcon}
            />
            <Typography className={styles.languageText}>
              {currentLanguage}
            </Typography>
            <ArrowDropDownIcon
              className={styles.dropdownIcon}
              fontSize="small"
            />
          </Box>
        </ListItem>
      </List>

      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        MenuListProps={{ "aria-labelledby": "language-button" }}
        slotProps={{ paper: { className: styles.languageMenu } }}
      >
        {supportedLanguages.map((row: ActiveLanguages) => (
          <MenuItem
            key={row.languageId}
            onClick={() => handleMenuItemClick(row)}
            className={styles.languageMenuItem}
          >
            <img
              src={
                LANGUAGE_ICONS[row.languageName] || LANGUAGE_ICONS["English"]
              }
              alt={row.languageName}
              className={styles.languageMenuIcon}
            />
            {row.languageName}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default CustomLanguage;
